// src/utils/limpiarSesion.js
//
// Seguridad Fase 3 (hallazgo A5): al cerrar sesión, borra del localStorage los
// datos sensibles cacheados (financieros + catálogos con emails de colaboradores)
// para no dejarlos a la vista en equipos compartidos.
//
// Es allowlist-DE-BORRADO: SOLO toca claves sensibles conocidas. NUNCA borra las
// claves de asistencia — la cola offline del kiosko (`asistencia_cola_marcas`), el
// id de dispositivo y las configs deben sobrevivir al cierre de sesión.

const CLAVES_EXACTAS = [
  'paralellum_catalogos_v1', // catálogos: incluye usuarios/emails de colaboradores
];

const PREFIJOS = [
  'financiero_capital_', // saldos/egresos/pedidos del mes por año-mes (dinero real)
  'auditoriaShopify_',   // cache de nombres de campañas publicitarias
];

export function limpiarStorageSensibleAlSalir() {
  try {
    CLAVES_EXACTAS.forEach((k) => localStorage.removeItem(k));
    // Recorrer de atrás hacia adelante porque removeItem reindexa el localStorage.
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const key = localStorage.key(i);
      if (key && PREFIJOS.some((p) => key.startsWith(p))) {
        localStorage.removeItem(key);
      }
    }
  } catch (e) {
    // localStorage deshabilitado/lleno: no bloquear el logout por esto.
  }
}
